export default "__VITE_ASSET__CSJBpI9G__"